import { fieldClass } from '@iws/admin-ui/field-class'

import { SelectHTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

/** A plain select with the admin field look; touch-friendly and fine for short lists. */
export const NativeSelect = ({
  options,
  className,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { options: { value: string; label: string }[] }) => (
  <select {...props} className={cn(fieldClass, 'h-11 rounded-sm', className)}>
    {options.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ))}
  </select>
)
